
import mixinFlexItem from './mixin-flex-item'

export default {
  name: 'VsFlexCol',
  mixins: [
    mixinFlexItem
  ],
  props: {
    span: {
      type: [String, Number, Object],
      default: null
    },
    offset: {
      type: [String, Number, Object],
      default: null
    },
    order: {
      type: [String, Number, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      $span: 'flexColSpan',
      $offset: 'flexColOffset',
      $order: 'gridColumnOrder'
    }
  }
}
